// SPDX-License-Identifier: AGPL-3.0-or-later

import {Endpoints} from '@app/features/app/constants/Endpoints';
import {http} from '@app/features/platform/transport/RestTransport';
import type {NameplateCatalogResponse} from '@fluxer/schema/src/domains/user/NameplateSchemas';

export async function fetchNameplateCatalog(): Promise<NameplateCatalogResponse> {
	const response = await http.get<NameplateCatalogResponse>(Endpoints.NAMEPLATES);
	return response.body;
}

export async function fetchNameplateMediaBytes(id: string): Promise<ArrayBuffer | null> {
	try {
		const response = await http.get<Blob | ArrayBuffer>(Endpoints.NAMEPLATE_MEDIA(id), {
			parse: 'binary',
			timeoutMs: 15_000,
		});
		if (!response.ok || response.body == null) {
			return null;
		}
		if (response.body instanceof ArrayBuffer) {
			return response.body;
		}
		if (response.body instanceof Blob) {
			return await response.body.arrayBuffer();
		}
		return null;
	} catch {
		return null;
	}
}
